import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';

import { SERVICE_ACTIVATION_LINK_TEXT, SERVICE_ACTIVATION_PATH_SUFFIXES } from '../constants';
import { SubscriptionAsset } from './SubscriptionAsset';
import { SubscriptionDetails } from './SubscriptionDetails';
import { SubscriptionMenu } from './SubscriptionMenu';
import { SubscriptionPrice } from './SubscriptionPrice';

function FeaturedProduct({ product, businessEntityUuid }) {
  const activationSuffix = SERVICE_ACTIVATION_PATH_SUFFIXES[product?.service];
  const activationPath = activationSuffix
    ? `/dashboard/${businessEntityUuid}${activationSuffix}`
    : null;
  const activationLinkText = SERVICE_ACTIVATION_LINK_TEXT[product?.service];

  return (
    <Box
      sx={(theme) => ({
        borderRadius: '1rem',
        padding: '1.5rem',
        display: 'grid',
        columnGap: '1.5rem',
        alignItems: 'center',
        gridTemplateColumns: 'max-content auto min-content',
        [theme.breakpoints.down('md')]: {
          gridTemplateRows: '1fr',
          gridTemplateColumns: 'auto min-content'
        }
      })}
    >
      <SubscriptionAsset service={product?.service} />
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="space-between"
        gap={4}
        sx={(theme) => ({
          [theme.breakpoints.up('md')]: {
            flexDirection: 'row'
          },
          [theme.breakpoints.down('md')]: {
            gridRow: 2,
            gridColumn: '1/-1'
          }
        })}
      >
        <SubscriptionDetails
          serviceName={product?.displayName || product?.service}
          summary={product?.summary}
          benefits={product?.benefits}
          activationPath={activationPath}
          activationLinkText={activationLinkText}
        />
        <SubscriptionPrice subscription={product} />
      </Stack>
      <SubscriptionMenu
        subscription={product}
        isIncluded
        businessEntityUuid={businessEntityUuid}
      />
    </Box>
  );
}

FeaturedProduct.propTypes = {
  product: PropTypes.shape({
    service: PropTypes.string,
    displayName: PropTypes.string,
    summary: PropTypes.string,
    benefits: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      description: PropTypes.string
    }))
  }),
  businessEntityUuid: PropTypes.string
};

export function FeaturedProducts({ includedProducts, businessEntityUuid }) {
  return (
    <Box sx={{ gridRow: 1 }}>
      {includedProducts?.map((product) => (
        <FeaturedProduct
          key={product?.orderBillingItemUuid ?? product?.service}
          product={product}
          businessEntityUuid={businessEntityUuid}
        />
      ))}
    </Box>
  );
}

FeaturedProducts.propTypes = {
  includedProducts: PropTypes.arrayOf(PropTypes.shape({
    service: PropTypes.string,
    displayName: PropTypes.string
  })),
  businessEntityUuid: PropTypes.string
};
